import { createStore } from 'vuex'
import { auth } from './auth.module';
import { proj } from './project.module';
import { permissions } from './permissions.module';
import { configs } from './configs.module';
import { routerblock } from './routerblock.module';

export default createStore({
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
      auth,
      proj,
      permissions,
      configs,
      routerblock
    }
  })